import React from 'react'

export const CustomLink = props => <a {...props}>{props.children}</a>
